import {BaseAttestation} from "@core/services/attestations";
import {AttestationBatch} from "@core/services/attestations/attestation-batch/attestation-batch.model";
import {Product} from "@core/services/settings/product/product.interface";
import {Company} from "@core/services/administration/company/company.interface";

export class StockStatus extends BaseAttestation {
  currentQuantity?: number;
  circulatedQuantity?: number;
  batch?: AttestationBatch;
  originUuid?: string;
  originLabel?: string;

  public constructor(entity: Partial<StockStatus> = {}) {
    super(entity);
    Object.assign(this, entity);
  }

  public static hydrate(entityList: StockStatus[], productList: Product[], companyList: Company[]): StockStatus[] {
    return entityList.map((item: StockStatus) => new StockStatus({
      ...item,
      batch: AttestationBatch.hydrate([item?.batch || new AttestationBatch({})], productList, companyList)[0],
    }))
  }

}
